import React from 'react';
import { Mail, Phone, FileText, Download, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { sponsorshipTiers } from './data';

const SponsorshipFormSection = ({
  formData,
  onChange,
  onSubmit,
  loading,
  error,
  submitted,
  onReset,
}) => (
  <section id="sponsor-form" className="sponsorship-form-section">
    <div className="container">
      <div className="form-wrapper">
        <div className="form-info">
          <h2>Ready to Sponsor?</h2>
          <p>Fill out the form and our team will be in touch to finalize your sponsorship.</p>

          <div className="payment-info">
            <h3><FileText size={20} /> Payment Information</h3>
            <p><strong>Make Checks Payable To:</strong> LRRPC - DM260</p>
            <p><strong>Memo Line:</strong> &quot;Randallstown Sponsorship&quot;</p>
            <p><strong>Mail To:</strong> 4027 Cedar Mill Rd, Randallstown, MD 21133</p>
            <p className="tax-note">Tax ID available upon request (501(c)(3) pending)</p>
          </div>

          <div className="contact-direct">
            <h3>Contact Us Directly</h3>
            <div className="contact-item">
              <Mail size={18} />
              <a href="mailto:Randallstownpanthers@gmail.com">Randallstownpanthers@gmail.com</a>
            </div>
            <div className="contact-item">
              <Phone size={18} />
              <a href="tel:410-790-0783">410-790-0783</a>
            </div>
            <p className="contact-name">Director: Christopher Barnes</p>
          </div>

          <div className="download-packet">
            <h3><Download size={20} /> Sponsorship Packet</h3>
            <p>Download our complete sponsorship packet with all tiers, benefits, and agreement form.</p>
            <a
              href="https://customer-assets.emergentagent.com/job_c1db756d-3e00-42a6-869e-ac51c49851dc/artifacts/2x7rjrhp_Youth_Football_and_Cheer_Sponsorship_Documents.docx"
              download="Randallstown_Panthers_Sponsorship_Packet.docx"
              className="download-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Download size={18} />
              Download Sponsorship Packet
            </a>
          </div>
        </div>

        <div className="form-card">
          {submitted ? (
            <div className="form-success">
              <div className="success-icon">✓</div>
              <h3>Thank You!</h3>
              <p>We&apos;ve received your sponsorship inquiry. Our team will contact you within 48 hours.</p>
              <Button onClick={onReset}>Submit Another Inquiry</Button>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="sponsor-form">
              <h3>Sponsorship Inquiry</h3>
              {error && <div className="form-error">{error}</div>}

              <div className="form-group">
                <label htmlFor="businessName">Business/Organization Name *</label>
                <input
                  type="text"
                  id="businessName"
                  name="businessName"
                  value={formData.businessName}
                  onChange={onChange}
                  required
                  placeholder="Your business name"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="contactName">Contact Name *</label>
                <input
                  type="text"
                  id="contactName"
                  name="contactName"
                  value={formData.contactName}
                  onChange={onChange}
                  required
                  placeholder="Your name"
                  disabled={loading}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="sponsor-email">Email *</label>
                  <input
                    type="email"
                    id="sponsor-email"
                    name="email"
                    value={formData.email}
                    onChange={onChange}
                    required
                    placeholder="email@business.com"
                    disabled={loading}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="sponsor-phone">Phone *</label>
                  <input
                    type="tel"
                    id="sponsor-phone"
                    name="phone"
                    value={formData.phone}
                    onChange={onChange}
                    required
                    placeholder="(XXX) XXX-XXXX"
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="selectedTier">Sponsorship Level *</label>
                <select
                  id="selectedTier"
                  name="selectedTier"
                  value={formData.selectedTier}
                  onChange={onChange}
                  required
                  disabled={loading}
                >
                  <option value="">Select a package...</option>
                  {sponsorshipTiers.map((tier) => (
                    <option key={tier.id} value={tier.name}>
                      {tier.name} ({tier.price})
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="sponsor-message">Additional Message</label>
                <textarea
                  id="sponsor-message"
                  name="message"
                  value={formData.message}
                  onChange={onChange}
                  placeholder="Any questions or special requests?"
                  rows={4}
                  disabled={loading}
                />
              </div>

              <Button type="submit" className="submit-btn" disabled={loading}>
                {loading ? (
                  <>
                    <Loader2 className="animate-spin" size={18} />
                    Submitting...
                  </>
                ) : (
                  'Submit Inquiry'
                )}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  </section>
);

export default SponsorshipFormSection;
